module.exports = __webpack_public_path__ + "static/media/student-insights.18e02495.svg";